/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(933);


/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setDropdownBehavior = exports.getElementIDWithType = exports.getMaterialName = exports.getSelectedRubrique = exports.getPageType = exports.memoizeSimple = exports.findPreviusAndNextWideEls = exports.checkOverlaps = exports.resolve = exports.getOrCreateUuid = exports.generateUserUuid = exports.getPartnersBlocksJSON = exports.getCachedWideEls = exports.getBoundingClientRect = exports.withYOffset = exports.queryWideEls = undefined;
	
	var _memoize2 = __webpack_require__(608);
	
	var _memoize3 = _interopRequireDefault(_memoize2);
	
	exports.isScrolledIntoView = isScrolledIntoView;
	exports.copyToClipboard = copyToClipboard;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var queryWideEls = exports.queryWideEls = function queryWideEls() {
	  return [].concat(_toConsumableArray(document.querySelectorAll('.js-wide-block')));
	};
	
	var withYOffset = exports.withYOffset = function withYOffset(value) {
	  return pageYOffset + value;
	};
	
	var getBoundingClientRect = exports.getBoundingClientRect = function getBoundingClientRect(el) {
	  return el.getBoundingClientRect();
	};
	
	// Возвращает функцию, которая кэширует результат ф-ии queryWideEls
	var getCachedWideEls = exports.getCachedWideEls = (0, _memoize3.default)(queryWideEls);
	
	/**
	 * Получает JSON партнерских блоков
	 *
	 * @param userUid {String} - уникальный токен пользователя
	 * @param blocksIds {String} - строка с числами разделенные запятой
	 *
	 * @returns {Promise}
	 */
	var getPartnersBlocksJSON = exports.getPartnersBlocksJSON = function getPartnersBlocksJSON(userUid, blockIds) {
	  var url = 'https://api.rnet.plus/service/blocks?ids=' + blockIds + '&user_id=' + userUid;
	  var width = window.screen.width;
	  var height = window.screen.height;
	  return new Promise(function (resolve) {
	    $.getJSON(url + (width + ' + x + ' + height), function (response) {
	      resolve(response);
	    });
	  });
	};
	
	/**
	 * generateUserUuid - генерирует
	 * уникальный токен пользователя
	 * @returns {String}
	 */
	var generateUserUuid = exports.generateUserUuid = function generateUserUuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    // eslint-disable-next-line
	    var r = Math.random() * 16 | 0,
	        v = c === 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	};
	
	/**
	 * getOrCreateUuid - создает или возвращает уникальный
	 * идентификатор пользователя
	 *
	 * @returns {String}
	 */
	var getOrCreateUuid = exports.getOrCreateUuid = function getOrCreateUuid() {
	  var keyName = 'RamblerExchangeUserId';
	  var uuid = void 0;
	  if (window.localStorage) {
	    uuid = localStorage.getItem(keyName);
	    if (!uuid) {
	      uuid = generateUserUuid();
	      localStorage.setItem(keyName, uuid);
	    }
	  }
	  return uuid;
	};
	
	/**
	 * isScrolledIntoView - проверяет находится ли элемент внутри вьюпорта
	 *
	 * @param elem - {Object} domNode
	 * @returns {Boolean}
	 */
	function isScrolledIntoView(elem) {
	  var docViewTop = $(window).scrollTop();
	  var docViewBottom = docViewTop + $(window).height();
	  var elemTop = $(elem).offset().top;
	  var elemBottom = elemTop + $(elem).height();
	  var elemLeft = $(elem).offset().left;
	  var style = getComputedStyle(elem);
	  var visibility = style.visibility;
	  var display = style.display;
	  var noSize = !$(elem).height() || !$(elem).width();
	  var isNotVisible = visibility === 'hidden' || display === 'none' || noSize || elemLeft < 0 || elemLeft > $(window).width();
	  if (isNotVisible) return false;
	  return elemBottom <= docViewBottom && elemTop >= docViewTop || elemBottom >= docViewBottom && elemTop <= docViewTop;
	}
	
	var resolve = exports.resolve = function resolve(path, obj, separator) {
	  var self = undefined;
	  return path.split(separator).reduce(function (prev, curr) {
	    return prev ? prev[curr] : null;
	  }, obj || self);
	};
	
	/**
	 * Проверяет наезжает ли визуально элемент на любой элемент из списка
	 *
	 * @param el {Object} domNode - проверяемый элемент
	 * @param els {Array} domNodeLists - список элементов
	 * @param addSpaceVal {Number} - Дополнительное пространство
	 * @param addSpaceStepVal {Number} - Значение каждого шага в доп.пространстве
	 *
	 * @returns {Boolean}
	 */
	var checkOverlaps = exports.checkOverlaps = function checkOverlaps(el, els) {
	  var addSpaceVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	  var addSpaceStepVal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
	
	  if (!el) return false;
	  var rect = el.getBoundingClientRect();
	  var overlaps = false;
	  var top = withYOffset(rect.top);
	  var bottom = withYOffset(rect.bottom);
	  els.forEach(function (wideEl) {
	    var wideElRect = wideEl.getBoundingClientRect();
	    var additionalSpace = 0;
	    while (additionalSpace <= addSpaceVal) {
	      var wideBottom = withYOffset(wideElRect.bottom) + additionalSpace;
	      var wideTop = withYOffset(wideElRect.top) - additionalSpace;
	
	      var topInWide = top > wideTop && top < wideBottom;
	      var bottomInWide = bottom > wideTop && bottom < wideBottom;
	
	      if (topInWide || bottomInWide) {
	        overlaps = true;
	      }
	
	      additionalSpace += addSpaceStepVal;
	    }
	  });
	  return overlaps;
	};
	
	/**
	 * Находит предыдущие и следующие элементы
	 * в зависимости от текущего положения el
	 *
	 * @param el {Object} - domNode
	 * @param els {Array} - list of domNodes
	 *
	 * @returns {Object}
	 */
	var findPreviusAndNextWideEls = exports.findPreviusAndNextWideEls = function findPreviusAndNextWideEls(el, list) {
	  var rects = list.map(getBoundingClientRect);
	  var rect = el.getBoundingClientRect();
	  var els = {
	    previus: {
	      el: null,
	      rect: null
	    },
	    next: {
	      el: null,
	      rect: null
	    }
	  };
	
	  var count = rects && rects.length > 0;
	  var search = true;
	  var i = 0;
	
	  while (count && search) {
	    var wideRect = rects[i];
	    var currentEl = list[i];
	    if (withYOffset(rect.bottom) < withYOffset(wideRect.top)) {
	      els.previus = {
	        el: currentEl,
	        rect: wideRect
	      };
	    }
	    if (withYOffset(rect.top) < withYOffset(wideRect.top)) {
	      els.next = {
	        el: currentEl,
	        rect: wideRect
	      };
	    }
	    if (!(els.next.el && els.previus.el)) {
	      i++;
	    } else {
	      search = false;
	    }
	  }
	  return els;
	};
	
	/**
	 * A simple memoize function that takes in a function and returns a memoized function
	 * @param  {Function} fn - function to cache
	 * @return {Function} fn - wrapped function
	 */
	var memoizeSimple = exports.memoizeSimple = function memoizeSimple(fn) {
	  var cache = {};
	  return function () {
	    var n = arguments.length <= 0 ? undefined : arguments[0]; // just taking one argument here
	    // return from cache
	    if (n in cache) {
	      return cache[n];
	    }
	    // return calc result
	    var result = fn(n);
	    cache[n] = result;
	    return result;
	  };
	};
	
	/**
	 * Возвращает тип страницы ('main - главная' | 'article - статья' | 'news - новость')
	 * @return {String}
	 */
	var getPageType = exports.getPageType = function getPageType() {
	  var pageType = '';
	  if (window.location.pathname === '/') {
	    pageType = 'main';
	  } else if (document.querySelector('.js-article')) {
	    pageType = 'article';
	  } else if (document.querySelector('.js-news')) {
	    pageType = 'news';
	  }
	  // Если тип страницы не удалось определить
	  if (pageType === '') {
	    // Вернем активную рубрику
	    pageType = getSelectedRubrique();
	  }
	  // Если рубрику не удалось определить
	  if (pageType === '') {
	    // Вернем pathname из location
	    pageType = window.location.pathname.replace(/\/*/g, '');
	  }
	  return pageType;
	};
	
	var getSelectedRubrique = exports.getSelectedRubrique = function getSelectedRubrique(el) {
	  var element = el || document.querySelector('.js-headline a.is-active');
	  var val = element && element.getAttribute('href').replace(/\/*/g, '');
	  if (!val && window.location.pathname === '/') {
	    return '';
	  }
	  return val;
	};
	
	var getMaterialName = exports.getMaterialName = function getMaterialName() {
	  var title = document.querySelector('h1') || document.querySelector('[itemprop=headline]');
	  var name = title && title.innerText;
	  if (!title || !name && window.location.pathname === '/') {
	    return '';
	  }
	  return name;
	};
	
	var getElementIDWithType = exports.getElementIDWithType = function getElementIDWithType(el) {
	  return el.getAttribute('data-id') || el.getAttribute('data-recomm-id');
	};
	
	/**
	 * Хелпер для создания простого поведения выпадающего меню
	 * Добавит на элемент с классом menuButtonClass eventListener который будет тогглить
	 * класс .is-open на элементе с классом menuClass. Добавляет общий для всех меню обработчик клика
	 * на document.body который закрывает меню при клике вне тела меню.
	 * @param menuButtonClass: String - класс элемента кнопки, по нажатии которой будет открываться меню
	 * @param menuClass: String - класс элмента тела меню
	 * @param container: Element - контейнер, в котором искать элементы, необязательный параметр
	 */
	var setDropdownBehavior = exports.setDropdownBehavior = function setDropdownBehavior(menuButtonClass, menuClass, container) {
	  var isMenuOpen = false;
	
	  var button = container ? container.querySelector(menuButtonClass) : document.querySelector(menuButtonClass);
	  var menu = container ? container.querySelector(menuClass) : document.querySelector(menuClass);
	
	  var menuCloseFn = function menuCloseFn() {
	    document.body.removeEventListener('click', menuCloseFn, false);
	    menu.classList.remove('is-open');
	    button.classList.remove('is-open');
	    isMenuOpen = false;
	  };
	
	  if (button && menu) {
	    button.addEventListener('click', function (e) {
	      e.stopPropagation();
	      button.classList.toggle('is-open');
	      menu.classList.toggle('is-open');
	      if (isMenuOpen) {
	        document.body.removeEventListener('click', menuCloseFn, false);
	        isMenuOpen = false;
	      } else {
	        document.body.addEventListener('click', menuCloseFn);
	        isMenuOpen = true;
	      }
	    });
	  }
	};
	
	function copyToClipboard(text) {
	  var elem = document.createElement('textarea');
	  elem.value = text;
	  elem.setAttribute('readonly', '');
	  elem.style.position = 'absolute';
	  elem.style.left = '-9999px';
	  elem.style.opacity = 0;
	  elem.style.height = 0;
	  document.body.appendChild(elem);
	  elem.select();
	  document.execCommand('copy');
	  document.body.removeChild(elem);
	}

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(609);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(610),
	    mapCacheDelete = __webpack_require__(637),
	    mapCacheGet = __webpack_require__(640),
	    mapCacheHas = __webpack_require__(641),
	    mapCacheSet = __webpack_require__(642);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(611),
	    ListCache = __webpack_require__(628),
	    Map = __webpack_require__(636);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(612),
	    hashDelete = __webpack_require__(624),
	    hashGet = __webpack_require__(625),
	    hashHas = __webpack_require__(626),
	    hashSet = __webpack_require__(627);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(613);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(614);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(615),
	    getValue = __webpack_require__(623);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(616),
	    isMasked = __webpack_require__(618),
	    isObject = __webpack_require__(617),
	    toSource = __webpack_require__(622);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(617);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ }),

/***/ 617:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(619);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(620);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(621);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),

/***/ 623:
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),

/***/ 624:
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(613);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(613);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(613);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(629),
	    listCacheDelete = __webpack_require__(630),
	    listCacheGet = __webpack_require__(633),
	    listCacheHas = __webpack_require__(634),
	    listCacheSet = __webpack_require__(635);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),

/***/ 629:
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(631);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(632);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),

/***/ 632:
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),

/***/ 633:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(631);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(631);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(631);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(614),
	    root = __webpack_require__(620);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(638);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(639);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),

/***/ 639:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(638);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(638);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(638);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function (t, l) {
	  "object" === ( false ? "undefined" : _typeof(exports)) && exports ? module.exports = l :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (l), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : t.Mustache = l;
	})(undefined, function () {
	  function t(a) {
	    return a.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
	  }function l(a) {
	    this.tail = this.string = a;this.pos = 0;
	  }function j(a, b) {
	    this.view = a;this.parent = b;this._cache = {};
	  }function m() {
	    this.clearCache();
	  }function r(a, b, c, f) {
	    for (var d = "", g, e, l = 0, j = a.length; l < j; ++l) {
	      switch (g = a[l], e = g[1], g[0]) {case "#":
	          e = c.lookup(e);if ("object" === (typeof e === "undefined" ? "undefined" : _typeof(e))) {
	            if (v(e)) for (var n = 0, h = e.length; n < h; ++n) {
	              d += r(g[4], b, c.push(e[n]), f);
	            } else e && (d += r(g[4], b, c.push(e), f));
	          } else "function" === typeof e ? (g = null == f ? null : f.slice(g[3], g[5]), e = e.call(c.view, g, function (a) {
	            return b.render(a, c);
	          }), null != e && (d += e)) : e && (d += r(g[4], b, c, f));break;case "^":
	          e = c.lookup(e);if (!e || v(e) && 0 === e.length) d += r(g[4], b, c, f);break;case ">":
	          e = b.getPartial(e);"function" === typeof e && (d += e(c));break;case "&":
	          e = c.lookup(e);null != e && (d += e);break;case "name":
	          e = c.lookup(e);null != e && (d += k.escape(e));break;case "text":
	          d += e;}
	    }return d;
	  }
	  function w(a) {
	    return [RegExp(t(a[0]) + "\\s*"), RegExp("\\s*" + t(a[1]))];
	  }var k = { name: "mustache.js", version: "0.7.2", tags: ["{{", "}}"] };k.Scanner = l;k.Context = j;k.Writer = m;var z = /\s*/,
	      x = /\s+/,
	      A = /\S/,
	      y = /\s*=/,
	      B = /\s*\}/,
	      C = /#|\^|\/|>|\{|&|=|!/,
	      D = RegExp.prototype.test,
	      E = Object.prototype.toString,
	      v = Array.isArray || function (a) {
	    return "[object Array]" === E.call(a);
	  },
	      F = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "/": "&#x2F;" };k.escape = function (a) {
	    return String(a).replace(/[&<>"'\/]/g, function (a) {
	      return F[a];
	    });
	  };
	  l.prototype.eos = function () {
	    return "" === this.tail;
	  };l.prototype.scan = function (a) {
	    return (a = this.tail.match(a)) && 0 === a.index ? (this.tail = this.tail.substring(a[0].length), this.pos += a[0].length, a[0]) : "";
	  };l.prototype.scanUntil = function (a) {
	    var b = this.tail.search(a);switch (b) {case -1:
	        a = this.tail;this.pos += this.tail.length;this.tail = "";break;case 0:
	        a = "";break;default:
	        a = this.tail.substring(0, b), this.tail = this.tail.substring(b), this.pos += b;}return a;
	  };j.make = function (a) {
	    return a instanceof j ? a : new j(a);
	  };j.prototype.push = function (a) {
	    return new j(a, this);
	  };j.prototype.lookup = function (a) {
	    var b = this._cache[a];if (!b) {
	      if ("." == a) b = this.view;else for (var c = this; c;) {
	        if (0 < a.indexOf(".")) for (var b = c.view, f = a.split("."), d = 0; b && d < f.length;) {
	          b = b[f[d++]];
	        } else b = c.view[a];if (null != b) break;c = c.parent;
	      }this._cache[a] = b;
	    }"function" === typeof b && (b = b.call(this.view));return b;
	  };m.prototype.clearCache = function () {
	    this._cache = {};this._partialCache = {};
	  };m.prototype.compile = function (a, b) {
	    var c = this._cache[a];c || (c = k.parse(a, b), c = this._cache[a] = this.compileTokens(c, a));return c;
	  };m.prototype.compilePartial = function (a, b, c) {
	    b = this.compile(b, c);return this._partialCache[a] = b;
	  };m.prototype.getPartial = function (a) {
	    !(a in this._partialCache) && this._loadPartial && this.compilePartial(a, this._loadPartial(a));return this._partialCache[a];
	  };m.prototype.compileTokens = function (a, b) {
	    var c = this;return function (f, d) {
	      if (d) if ("function" === typeof d) c._loadPartial = d;else for (var g in d) {
	        c.compilePartial(g, d[g]);
	      }return r(a, c, j.make(f), b);
	    };
	  };m.prototype.render = function (a, b, c) {
	    return this.compile(a)(b, c);
	  };k.parse = function (a, b) {
	    a = a || "";b = b || k.tags;"string" === typeof b && (b = b.split(x));if (2 !== b.length) throw Error("Invalid tags: " + b.join(", "));for (var c = w(b), f = new l(a), d = [], g = [], e = [], j = !1, m = !1, n, h, p, s; !f.eos();) {
	      n = f.pos;if (p = f.scanUntil(c[0])) {
	        s = 0;for (var r = p.length; s < r; ++s) {
	          if (h = p.charAt(s), D.call(A, h) ? m = !0 : e.push(g.length), g.push(["text", h, n, n + 1]), n += 1, "\n" == h) {
	            if (j && !m) for (; e.length;) {
	              delete g[e.pop()];
	            } else e = [];m = j = !1;
	          }
	        }
	      }if (!f.scan(c[0])) break;j = !0;h = f.scan(C) || "name";
	      f.scan(z);"=" === h ? (p = f.scanUntil(y), f.scan(y), f.scanUntil(c[1])) : "{" === h ? (p = f.scanUntil(RegExp("\\s*" + t("}" + b[1]))), f.scan(B), f.scanUntil(c[1]), h = "&") : p = f.scanUntil(c[1]);if (!f.scan(c[1])) throw Error("Unclosed tag at " + f.pos);s = [h, p, n, f.pos];g.push(s);if ("#" === h || "^" === h) d.push(s);else if ("/" === h) {
	        if (0 === d.length) throw Error('Unopened section "' + p + '" at ' + n);h = d.pop();if (h[1] !== p) throw Error('Unclosed section "' + h[1] + '" at ' + n);
	      } else if ("name" === h || "{" === h || "&" === h) m = !0;else if ("=" === h) {
	        b = p.split(x);
	        if (2 !== b.length) throw Error("Invalid tags at " + n + ": " + b.join(", "));c = w(b);
	      }
	    }if (h = d.pop()) throw Error('Unclosed section "' + h[1] + '" at ' + f.pos);for (var c = g, f = [], q, g = 0, e = c.length; g < e; ++g) {
	      if (d = c[g]) "text" === d[0] && q && "text" === q[0] ? (q[1] += d[1], q[3] = d[3]) : (q = d, f.push(d));
	    }q = f;f = c = [];d = [];e = 0;for (j = q.length; e < j; ++e) {
	      switch (g = q[e], g[0]) {case "#":case "^":
	          d.push(g);f.push(g);f = g[4] = [];break;case "/":
	          d.pop()[5] = g[2];f = 0 < d.length ? d[d.length - 1][4] : c;break;default:
	          f.push(g);}
	    }return c;
	  };var u = new m();k.clearCache = function () {
	    return u.clearCache();
	  };
	  k.compile = function (a, b) {
	    return u.compile(a, b);
	  };k.compilePartial = function (a, b, c) {
	    return u.compilePartial(a, b, c);
	  };k.compileTokens = function (a, b) {
	    return u.compileTokens(a, b);
	  };k.render = function (a, b, c) {
	    return u.render(a, b, c);
	  };k.to_html = function (a, b, c, f) {
	    a = k.render(a, b, c);if ("function" === typeof f) f(a);else return a;
	  };return k;
	}());

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _helpers = __webpack_require__(673);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EggService = function () {
	  function EggService() {
	    _classCallCheck(this, EggService);
	
	    this.ee = window.Daily.ee;
	    this.initialize();
	  }
	
	  _createClass(EggService, [{
	    key: '_setListeners',
	    value: function _setListeners() {
	      var _this = this;
	
	      // Когда узнали подписку пользователя, отправляем pageView
	      window.Daily.ee.on('primeStatusChecked', function () {
	        _this.pageView(window.location.href, document.referer);
	      });
	    }
	  }, {
	    key: 'initialize',
	    value: function initialize() {
	      this._setListeners();
	    }
	  }, {
	    key: '_checkEF',
	    value: function _checkEF() {
	      if (!window.EF) {
	        throw new Error('cant find ef');
	      }
	    }
	
	    /**
	     * Отправляет событие просмотра страницы
	     * @param url {string}
	     * @param referer {string}
	     */
	
	  }, {
	    key: 'pageView',
	    value: function pageView(url, referer) {
	      var _url = url ? url : '';
	      var _referer = referer ? referer : '';
	      // Проверяем доступность
	      this._checkEF();
	      // Отправляем событие
	      window.EF.send('pageview', {
	        url: _helpers2.default.url.toAbsolute(_url),
	        referer: _helpers2.default.url.toAbsolute(_referer),
	        extra: {
	          user_rsid: window.rsid,
	          mobile: window.is_mobile
	        }
	      });
	    }
	  }]);
	
	  return EggService;
	}();
	
	var service = new EggService();
	exports.default = service;

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Конвектирует урл в абсолютный
	 * @param relativeUrl {string}
	 * @returns {string}
	 */
	var toAbsolute = function toAbsolute(relativeUrl) {
	  return new URL(relativeUrl, window.location.origin).href;
	};
	
	/**
	 * Конвектирует абсолютный в relative
	 * @param absoluteUrl
	 * @returns {string}
	 */
	var toRelative = function toRelative(absoluteUrl) {
	  var URL_ = new URL(absoluteUrl, window.location.origin);
	  return URL_.pathname + URL_.search + URL_.hash;
	};
	
	exports.default = {
	  url: {
	    toAbsolute: toAbsolute,
	    toRelative: toRelative
	  }
	};

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forceLogout = exports.closeIframeAuth = exports.openIframeAuth = undefined;
	
	var _config = __webpack_require__(934);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _userApi = __webpack_require__(935);
	
	var _helpers = __webpack_require__(939);
	
	var _egg = __webpack_require__(672);
	
	var _egg2 = _interopRequireDefault(_egg);
	
	var _mindbox = __webpack_require__(949);
	
	var _mindbox2 = _interopRequireDefault(_mindbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	// eslint-disable-next-line no-unused-vars
	
	// eslint-disable-next-line no-unused-vars
	
	
	/**
	 * Проверяет есть ли открытый Iframe авторизации
	 * @private
	 * @return { Boolean }
	 */
	var checkIfIframeIsExist = function checkIfIframeIsExist() {
	  var url = '//id.rambler.ru/login-20/';
	  var iframes = [].concat(_toConsumableArray(document.querySelectorAll('iframe')));
	  var found = false;
	  for (var i = 0; i <= iframes.length - 1; i++) {
	    var iframe = iframes[0];
	    if (iframe) {
	      var src = String(iframe.getAttribute('src'));
	      found = src && src.includes(url);
	      if (found) {
	        break;
	      }
	    }
	  }
	  return found;
	};
	
	/**
	 * Открывает IFrame с формой авторизации
	 * @public
	 */
	var openIframeAuth = exports.openIframeAuth = (0, _helpers.debounce)(function () {
	  // Проверим что нету открытых iframe
	  if (checkIfIframeIsExist()) return;
	  // Скрипт исполняется на мобилке?
	  var isMobile = window.is_mobile;
	  var options = {
	    // Редирект url - как указано в документации
	    path: _config2.default.redirectTo,
	    // Идентификатор проекта
	    rname: _config2.default.rname,
	    // Выбранная тема для форм авторизации
	    theme: isMobile ? _config2.default.themeNames.mobile : _config2.default.themeNames.desktop
	  };
	  // Вызовем
	  // через idHelper Iframe форму
	  // для авторизации, (регистрации)
	  window.ramblerIdHelper.openAuth(options);
	}, 5000);
	
	/**
	 * Закрывает окно авторизации с Iframe
	 * @public
	 */
	var closeIframeAuth = exports.closeIframeAuth = function closeIframeAuth() {
	  window.ramblerIdHelper.closeAuth();
	};
	
	/**
	 * Выйти отовсюду (daily, ramblerId)
	 * @public
	 */
	var forceLogout = exports.forceLogout = function forceLogout() {
	  // Вызываем метод для выхода в ID
	  window.ramblerIdHelper.logout();
	  // Помечаем что был форсированный выход в LS
	  localStorage.setItem(_config2.default.keys.FORCE_RID, true);
	};
	
	/**
	 * Разлогиниться на уровне "Daily"
	 * @private
	 */
	var dailyLogout = function dailyLogout() {
	  localStorage.removeItem(_config2.default.keys.USER_KEY);
	};
	
	/**
	 * Обновляет данные пользователя
	 */
	var refreshProfileInfo = function refreshProfileInfo() {
	  window.ramblerIdHelper.getProfileInfo({ get_chain_id: 1 }, function (data) {
	    if (data) {
	      var chain_id = data.info.chain_id;
	      // Запишем токен пользователя в LS
	
	      localStorage.setItem(_config2.default.keys.USER_KEY, chain_id.default);
	    }
	  });
	};
	
	/**
	 * Сохраняет данные пользователя
	 * @private
	 * @param rid
	 */
	var setRidInStorage = function setRidInStorage(rid) {
	  if (rid) {
	    localStorage.setItem(_config2.default.keys.USER_KEY, rid);
	    var userViewModel = (0, _userApi.getUserViewModelFromLocalStorage)();
	    if (userViewModel) {
	      (0, _userApi.updateState)(userViewModel, true);
	    } else {
	      refreshProfileInfo();
	    }
	  } else {
	    refreshProfileInfo();
	  }
	};
	
	/**
	 * Функция должна вызываться при логине пользователя (registerPossibleOauthLoginCallback)
	 * @private
	 * @callback
	 * @param rid
	 */
	var getTokenAndAutoLogin = function getTokenAndAutoLogin(rid) {
	  // Получаем токен авторизованного пользователя у ID
	  window.ramblerIdHelper.getSessionToken(function (data) {
	    if (data && data.token) {
	      // Если есть токен, сохраняем его в LocalStorage
	      setRidInStorage(rid);
	    }
	  });
	};
	
	/**
	 * Функция должна вызываться при logout пользователя
	 * @callback
	 * @comment debounce - нужен для того, чтобы ослабить багу с зацикливанием post-message
	 */
	var onLogout = (0, _helpers.debounce)(function () {
	  if (localStorage.getItem(_config2.default.keys.FORCE_RID)) {
	    // Снимаем флаг с LocalStorage
	    localStorage.removeItem(_config2.default.keys.FORCE_RID);
	  } else {
	    // Наша функция деоавторизации
	    dailyLogout();
	  }
	  // Удаляем данные пользователя
	  localStorage.removeItem(_config2.default.keys.USER_DATA_KEY);
	  // Обновим стейт пользователя
	  (0, _userApi.updateState)(null, false);
	}, 5000);
	
	/**
	 * Иницилизируем RamblerIDHelper
	 * Запрашивает данные пользователя в ramblerID
	 * Подписывается на нужные события ID сервиса
	 */
	var initRamblerIdService = function initRamblerIdService() {
	  var onLogoutCb = function onLogoutCb() {
	    onLogout();
	  };
	
	  // Регистрируем обработчик на событие
	  // авторизации пользователя через социальные сети
	  window.ramblerIdHelper.registerOnPossibleOauthLoginCallback(function () {
	    getTokenAndAutoLogin();
	  });
	
	  // Подписываемся на событие авторизации в ramblerID
	  window.ramblerIdHelper.addListener('login', function () {
	    getTokenAndAutoLogin();
	  });
	
	  // Подписываем на выход из ramblerID
	  window.ramblerIdHelper.addListener('logout', onLogoutCb);
	
	  // Получаем данные пользователя
	  window.ramblerIdHelper.getProfileInfo({ get_chain_id: 1 }, function (data) {
	    var rsdix = localStorage.getItem(_config2.default.keys.USER_KEY);
	    // Если данных о пользователе нет, значит мы не авторизованы
	    if (!data) {
	      // Нужно убрать идентификатор пользователя из localStorage
	      // И сделать разлогин на уровне "проекта"
	      rsdix && dailyLogout();
	      // Обновим стейт
	      (0, _userApi.updateState)(null, false);
	      // Посылаем событие в шину
	      window.Daily.ee.emit('notauthorized');
	      return;
	    }
	
	    // Если данные есть
	    var chain_id = data.info.chain_id;
	
	    // Получим идентификатор пользователя
	
	    var _rsidx = chain_id.default;
	
	    // Сделаем идентификатор пользователя глобально доступным для скриптов AdTech
	    window.rid = _rsidx;
	
	    // Посылаем событие в шину
	    window.Daily.ee.emit('authorized', window.rid);
	
	    // Если сохраненный ключ не равен, тому что сейчас в ramblerID
	    if (_rsidx !== rsdix) {
	      // Сохраняем токен на нашей стороне в LocalStorage
	      getTokenAndAutoLogin(_rsidx);
	      // Если токен не изменился
	    }
	  });
	};
	
	// Иницилизируем скрипт когда хелпер будет загрузжен
	window.ramblerIdHelper.push(function () {
	  // Когда асинхронный SDK RamblerID подгрузился
	  // Иницилизируем авторизацию пользователя
	  initRamblerIdService();
	});

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Конфигурация для работы с ramblerId
	 */
	var config = {
	  // Имя проекта
	  rname: 'afishaDaily',
	  // Ссылка для логина в ramblerID
	  redirectTo: '/login-20/login',
	  // Названия тем для форм
	  themeNames: {
	    desktop: 'afisha-daily',
	    mobile: 'afisha-daily-mobile'
	  },
	  // Названия ключей в localStorage
	  keys: {
	    /**
	     * Посмотреть какое значение будет принимать этот ключ
	     */
	    FORCE_RID: 'forceRid',
	
	    /**
	     * Ключ для хранения RSIDX токена пользователя в LocalStorage
	     * @type {string}
	     */
	    USER_KEY: 'dailyAuthUserToken',
	    /**
	     * Ключ для хранения ViewModel пользователя
	     */
	    USER_DATA_KEY: 'dailyAuthUserViewModel'
	  },
	  /**
	   * Значение для Prime
	   */
	  referrer: 'https://daily.afisha.com'
	};
	
	exports.default = config;

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserViewModelFromLocalStorage = exports.updateSubscriptionInUserState = exports.updateState = exports.saveUserData = exports.userViewModelBuilder = undefined;
	
	var _config = __webpack_require__(934);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _userState = __webpack_require__(936);
	
	var _userState2 = _interopRequireDefault(_userState);
	
	var _userModel = __webpack_require__(937);
	
	var _userModel2 = _interopRequireDefault(_userModel);
	
	var _ui = __webpack_require__(938);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Сохраняет модель пользователя в LocalStorage
	 * @private
	 * @param { UserViewModel } user
	 */
	var saveUserViewModelToLocalStorage = function saveUserViewModelToLocalStorage(user) {
	  var userJsonString = JSON.stringify(user);
	  localStorage.setItem(_config2.default.keys.USER_DATA_KEY, userJsonString);
	};
	
	/**
	 * Создает модель пользователя
	 * @public
	 * @param ramblerIdUserData
	 * @returns {UserViewModel}
	 */
	var userViewModelBuilder = exports.userViewModelBuilder = function userViewModelBuilder(ramblerIdUserData) {
	  return new _userModel2.default(ramblerIdUserData);
	};
	
	/**
	 * Сохраняет данные пользователя в localStorage
	 * @public
	 * @param _data
	 */
	var saveUserData = exports.saveUserData = function saveUserData(_data) {
	  // Создаем нашу модель пользователя
	  var userViewModel = userViewModelBuilder(_data);
	  // Сохраняем модель пользователя в localStorage
	  saveUserViewModelToLocalStorage(userViewModel);
	  // Вернем пользователя
	  return userViewModel;
	};
	
	/**
	 * Обновляет стейт пользователя
	 * @public
	 * @param userViewModel - модель пользователя
	 * @param authorized - авторизован?
	 */
	var updateState = exports.updateState = function updateState(userViewModel, authorized) {
	  if (userViewModel) {
	    _userState2.default.user = userViewModel;
	  }
	  _userState2.default.isAuthorized = authorized;
	  // Перерисуем пользователя в шапке
	  (0, _ui.renderAuthElementsInHeader)(_userState2.default);
	};
	
	/**
	 * Обновляет статус подписки в стейте пользователя
	 * @public
	 * @returns { Boolean }
	 */
	var updateSubscriptionInUserState = exports.updateSubscriptionInUserState = function updateSubscriptionInUserState(hasSubscription) {
	  if (_userState2.default.hasSubscription !== hasSubscription) {
	    _userState2.default.hasSubscription = hasSubscription;
	    // Перерисуем пользователя в шапке
	    (0, _ui.renderAuthElementsInHeader)(_userState2.default);
	  }
	};
	
	/**
	 * Получает сохраненную модель пользователя из LocalStorage
	 * @public
	 * @returns {*}
	 */
	var getUserViewModelFromLocalStorage = exports.getUserViewModelFromLocalStorage = function getUserViewModelFromLocalStorage() {
	  var userJsonString = localStorage.getItem(_config2.default.keys.USER_DATA_KEY);
	  var userViewModel = null;
	  if (userJsonString) {
	    userViewModel = JSON.parse(userJsonString);
	  }
	  return userViewModel;
	};

/***/ }),

/***/ 936:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Стейт пользователя
	 * @type {{isAuthorized: boolean, user: null}}
	 */
	var userState = {
	  isAuthorized: false,
	  hasSubscription: null,
	  user: null
	};
	
	exports.default = userState;

/***/ }),

/***/ 937:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UserViewModel = function UserViewModel(ramblerIdUserData) {
	  _classCallCheck(this, UserViewModel);
	
	  var display = ramblerIdUserData.display,
	      profile = ramblerIdUserData.profile,
	      info = ramblerIdUserData.info;
	  // Телефон если есть
	
	  this.phone = ramblerIdUserData.phones && ramblerIdUserData.phones[0] || null;
	  // Полное имя для отображения
	  this.name = display.display_name;
	  // Короткое имя для отображения
	  this.shortName = display.short_name;
	  // Ссылка на аватар
	  this.avatar = display.avatar.url;
	  // Email пользователя
	  this.email = info.email;
	  // Пол
	  this.gender = profile.gender;
	};
	
	exports.default = UserViewModel;

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderAuthElementsInHeader = undefined;
	
	var _helpers = __webpack_require__(939);
	
	var _index = __webpack_require__(940);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(945);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _userState = __webpack_require__(936);
	
	var _userState2 = _interopRequireDefault(_userState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Функция рендерит элементы авторизации для пользователя в шапку сайта
	 */
	var renderAuthElementsInHeader = exports.renderAuthElementsInHeader = function renderAuthElementsInHeader() {
	  var isMobile = (0, _helpers.checkIsMobile)();
	  if (!isMobile) {
	    (0, _index2.default)(_userState2.default);
	  } else {
	    (0, _index4.default)(_userState2.default);
	  }
	};

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Проверяет скрипт выполняется на мобильной версии?
	 * @public
	 * @returns {boolean}
	 */
	var checkIsMobile = exports.checkIsMobile = function checkIsMobile() {
	  return window.is_mobile === true;
	};
	
	var buildCustomEvent = exports.buildCustomEvent = function buildCustomEvent(name) {
	  return new Event(name);
	};
	
	var debounce = exports.debounce = function debounce(f, ms) {
	  var isCooldown = false;
	  return function () {
	    if (isCooldown) return;
	    f.apply(this, arguments);
	    isCooldown = true;
	    setTimeout(function () {
	      return isCooldown = false;
	    }, ms);
	  };
	};

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(941);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _mustache = __webpack_require__(651);
	
	var _mustache2 = _interopRequireDefault(_mustache);
	
	var _ramblerId = __webpack_require__(933);
	
	var _analytics = __webpack_require__(944);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _helpers = __webpack_require__(939);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var container = document.body.querySelector('.js-personal');
	
	var missClickListener = function missClickListener(_ref) {
	  var target = _ref.target;
	
	  var inside = target === container || container.contains(target);
	  if (!inside) {
	    container.classList.remove('is-opened');
	  }
	};
	
	var closeProfileMenu = function closeProfileMenu() {
	  container.classList.remove('is-opened');
	};
	
	var openProfileMenu = function openProfileMenu() {
	  container.classList.add('is-opened');
	};
	
	var onProfileMenuClick = function onProfileMenuClick() {
	  if (container.classList.contains('is-opened')) {
	    closeProfileMenu();
	  } else {
	    openProfileMenu();
	  }
	};
	
	var clickListener = function clickListener(_ref2) {
	  var target = _ref2.target;
	  var classList = target.classList;
	
	  var actionLogIn = classList.contains('js-login');
	  var actionLogOut = classList.contains('js-logout');
	  var actionPersonalSub = classList.contains('js-personal-subscription');
	  var actionPersonalAdvOff = classList.contains('js-personal-adv-off');
	  var actionOpenProfileMenu = classList.contains('js-profile');
	  var actionProfile = classList.contains('js-personal-account');
	  if (actionLogIn) {
	    (0, _analytics2.default)('click', 'login');
	    (0, _ramblerId.openIframeAuth)();
	  } else if (actionLogOut) {
	    (0, _ramblerId.forceLogout)();
	    closeProfileMenu();
	  } else if (actionOpenProfileMenu) {
	    onProfileMenuClick();
	  } else if (actionProfile) {
	    closeProfileMenu();
	  }
	  if (actionPersonalAdvOff) {
	    (0, _analytics2.default)('click', 'disableAdv');
	  }
	  if (actionPersonalSub) {
	    closeProfileMenu();
	    (0, _analytics2.default)('click', 'profile');
	  }
	};
	
	var renderLogIn = function renderLogIn(userState) {
	  var profileHTML = _mustache2.default.render(_index2.default.authorized, userState);
	  if (container) container.innerHTML = profileHTML;
	};
	
	var renderLogOut = function renderLogOut(userState) {
	  var logoutHTML = _mustache2.default.render(_index2.default.unauthorized, userState);
	  if (container) container.innerHTML = logoutHTML;
	};
	
	if (container && !(0, _helpers.checkIsMobile)()) {
	  container.addEventListener('click', clickListener);
	}
	
	document.body.addEventListener('click', function (e) {
	  missClickListener(e);
	});
	
	var sendShowProfileAnalyticsOnce = function sendShowProfileAnalyticsOnce(state) {
	  if (!sendShowProfileAnalyticsOnce.alreadySent) {
	    var isNotAuthorized = state.isAuthorized === false;
	    if (isNotAuthorized) {
	      (0, _analytics2.default)('show', 'login');
	    }
	    if (state.hasSubscription === false || isNotAuthorized) {
	      (0, _analytics2.default)('show', 'disableAdv');
	    }
	    sendShowProfileAnalyticsOnce.alreadySent = true;
	  }
	};
	
	/**
	 * В зависимости от того, авторизован ли пользователь,
	 * рендерит соответствующую шапку
	 * @param {*} state
	 */
	var renderDesktopAuthElsInHeader = function renderDesktopAuthElsInHeader(state) {
	  state.subscriptionLink = window.AdvDailyHelper.subscriptionLink;
	  if (state.isAuthorized) {
	    renderLogIn(state);
	  } else {
	    renderLogOut(state);
	  }
	  sendShowProfileAnalyticsOnce(state);
	};
	
	exports.default = renderDesktopAuthElsInHeader;

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authorized = __webpack_require__(942);
	
	var _authorized2 = _interopRequireDefault(_authorized);
	
	var _unauthorized = __webpack_require__(943);
	
	var _unauthorized2 = _interopRequireDefault(_unauthorized);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var templates = { authorized: _authorized2.default, unauthorized: _unauthorized2.default };
	
	exports.default = templates;

/***/ }),

/***/ 942:
/***/ (function(module, exports) {

	module.exports = "{{ #user }}\n  <div class=\"personal__photo js-profile\"{{ #avatar }} style=\"background-image: url('{{{ avatar }}}')\"{{ /avatar }}>\n    {{ ^avatar }}\n      {{ #shortName }}\n      <span class=\"personal__name\">{{{ shortName }}}</span>\n      {{ /shortName }}\n    {{ /avatar }}\n  </div>\n  <div class=\"personal__menu\">\n    <a href=\"//id.rambler.ru/account/profile\" target=\"_blank\" class=\"personal__menu-link js-personal-account\">Мой профиль</a>\n      {{ #hasSubscription }}\n        <a href=\"//id.rambler.ru/account/subscriptions?project=afishaDaily\" class=\"personal__menu-link personal__adv-off js-personal-subscription\" target=\"_blank\">Управление подпиской</a>\n      {{ /hasSubscription }}\n    <div class=\"personal__menu-link js-logout\">Выйти</div>\n  </div>\n{{ /user }}\n\n";

/***/ }),

/***/ 943:
/***/ (function(module, exports) {

	module.exports = "<div class=\"personal__link js-login\" data-element-click=\"headline__login\">Войти</div>\n";

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _common = __webpack_require__(607);
	
	var gaMap = {
	  click: {
	    login: {
	      hitType: 'event',
	      eventCategory: 'Profile',
	      eventAction: 'Login_Click',
	      eventLabel: ''
	    },
	    disableAdv: {
	      hitType: 'event',
	      eventCategory: 'Ads',
	      eventAction: 'Header_Turn_off_Click',
	      eventLabel: ''
	    }
	  },
	  show: {
	    login: {
	      hitType: 'event',
	      eventCategory: 'Profile',
	      eventAction: 'Login_OnShow',
	      eventLabel: ''
	    },
	    disableAdv: {
	      hitType: 'event',
	      eventCategory: 'Ads',
	      eventAction: 'Header_Turn_off_OnShow',
	      eventLabel: ''
	    }
	  }
	};
	
	var sendPrimeAnalytics = function sendPrimeAnalytics(action, category) {
	  var gaParams = gaMap[action][category];
	  if (gaParams) {
	    gaParams.eventLabel = (0, _common.getPageType)();
	    gaParams && window.sendAnalytics(gaParams);
	  }
	};
	
	exports.default = sendPrimeAnalytics;

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mustache = __webpack_require__(651);
	
	var _mustache2 = _interopRequireDefault(_mustache);
	
	var _templates = __webpack_require__(946);
	
	var _templates2 = _interopRequireDefault(_templates);
	
	var _ramblerId = __webpack_require__(933);
	
	var _analytics = __webpack_require__(944);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _helpers = __webpack_require__(939);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var personalEl = document.querySelector('.js-personal');
	var menuButtonEl = document.querySelector('.js-dropdown-menu-button');
	
	/**
	 * Общий обработчик событий DOM контейнера с профилем
	 * @param event
	 */
	var clickHandler = function clickHandler(event) {
	  var target = event.target;
	  var classList = target.classList;
	
	
	  if (classList.contains('js-login')) {
	    (0, _analytics2.default)('click', 'login');
	    (0, _ramblerId.openIframeAuth)();
	  }
	
	  if (classList.contains('js-logout')) {
	    (0, _ramblerId.forceLogout)();
	  }
	};
	
	var sendShowProfileAnalyticsOnce = function sendShowProfileAnalyticsOnce() {
	  if (!sendShowProfileAnalyticsOnce.alreadySent) {
	    (0, _analytics2.default)('show', 'login');
	    sendShowProfileAnalyticsOnce.alreadySent = true;
	  }
	};
	
	/**
	 * Функция рендера мобильного блока с профилем пользователя
	 * @param state - статус пользователя, залогинен/разлогинен
	 */
	var renderMobileAuthElsInHeader = function renderMobileAuthElsInHeader(state) {
	  var rootEl = personalEl || document.querySelector('.js-personal');
	  state.subscriptionLink = window.AdvDailyHelper.subscriptionLink;
	  rootEl.innerHTML = _mustache2.default.render(state.isAuthorized ? _templates2.default.authorized : _templates2.default.notauthorized, { state: state });
	};
	
	if (personalEl && (0, _helpers.checkIsMobile)()) {
	  // Add clickListener
	  personalEl.addEventListener('click', clickHandler);
	}
	
	menuButtonEl && menuButtonEl.addEventListener('click', sendShowProfileAnalyticsOnce.bind(undefined));
	
	exports.default = renderMobileAuthElsInHeader;

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authorized = __webpack_require__(947);
	
	var _authorized2 = _interopRequireDefault(_authorized);
	
	var _notauthorized = __webpack_require__(948);
	
	var _notauthorized2 = _interopRequireDefault(_notauthorized);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { authorized: _authorized2.default, notauthorized: _notauthorized2.default };

/***/ }),

/***/ 947:
/***/ (function(module, exports) {

	module.exports = "<div class=\"personal__wrapper\">\n    <div class=\"personal__avatar js-avatar {{ ^state.user.avatar }}personal__avatar--initials{{ /state.user.avatar }}\"\n     {{ #state.user.avatar }}\n        style=\"background-image: url('{{{ state.user.avatar }}}')\"\n     {{ /state.user.avatar }}>\n     {{ ^state.user.avatar }}\n        {{ state.user.shortName }}\n     {{ /state.user.avatar }}\n    </div>\n\n    <div class=\"personal__menu-wrap\">\n        <a href=\"//id.rambler.ru/account/profile\" target=\"_blank\" class=\"personal__menu-item js-profile\">\n            Мой профиль\n        </a>\n\n        {{ #state.hasSubscription }}\n            <a href=\"//id.rambler.ru/account/subscriptions?project=afishaDaily\" class=\"personal__menu-item\" target=\"_blank\">\n                Управление подпиской\n            </a>\n        {{ /state.hasSubscription }}\n    </div>\n\n    <div class=\"personal__menu-item personal__menu-item--logout js-logout\">Выйти</div>\n</div>\n";

/***/ }),

/***/ 948:
/***/ (function(module, exports) {

	module.exports = "<div class=\"personal__login-btn js-login\">ВОЙТИ</div>\n\n";

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _sha = __webpack_require__(950);
	
	var _userApi = __webpack_require__(935);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @description Мапа с короткими названиями, на названия операции в EggAfisha
	 * @see https://egg.afisha.ru/operations - искать операции по значению в ключах
	 * @enum {string} - строковые идентификаторы операций из EggAfisha
	 * P.S: События по виджету кассы - касса отправляет сама из виджета
	 */
	var OPERATIONS = {
	  // Подписка на email рассылку
	  // Отправляем операцию при получении ответа от сервера при подписке пользователя на email рассылку
	  'SUBSCRIBE': 'Website.Afisha.Daily.Subscribe',
	  // Авторизация в RamblerID
	  // Отправляем только при авторизации на сайте - получении пользователя
	  'AUTH': 'Website.Afisha.Daily.AuthenticatedOnWebsite'
	};
	
	/**
	 * @description Класс инкапсулирует логику отправки операций в EggAfisha
	 * @see https://egg.afisha.ru/operations
	 * @see https://docs.google.com/document/d/1UDIMPY8_tGFlXEotFKUgP8aFn9sUfhNj4qajgpK0G6I/edit#
	 */
	
	var MindBoxService = function () {
	  function MindBoxService() {
	    _classCallCheck(this, MindBoxService);
	
	    // Запишем ссылку наш EE в класс
	    this.ee = window.Daily.ee;
	    // this.debug = true;
	    // Если вдруг сломали - кинем error
	    if (!this.ee) {
	      throw new Error('Cant find Daily Event Emitter');
	    }
	    // Подпишемся на внешние события (авторизация, подписка на email)
	    this._setListeners();
	  }
	
	  /**
	   * @description Отправляет операцию в EggAfisha, а сервис Афишы в MindBox
	   * @param operation {OPERATIONS}
	   * @param payload {Object<string, any>}
	   * @private
	   */
	
	
	  _createClass(MindBoxService, [{
	    key: '_send',
	    value: function _send(operation, payload) {
	      if (this.debug) {
	        console.log('send operation', operation);
	      }
	      return window.EF.send('operation', { name: operation, body: payload });
	    }
	
	    /**
	     * Подписываемся на события
	     * @private
	     */
	
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      var _this = this;
	
	      // Подписываемся на событие авторизации пользователя
	      this.ee.on('authorized', function () {
	        // Отправляем операцию
	        _this.auth();
	      });
	      // Подписываемся на событие email подписки (Desktop/Mobile)
	      this.ee.on('email-subscribe', function (email, response) {
	        // Отправляем операцию о подписки на email
	        _this.emailSubscribe(email, response);
	      });
	    }
	
	    /**
	     * @description Собирает данные пользователя экспортированные из ramblerID
	     * @private
	     */
	
	  }, {
	    key: '_getPrivateUserInfo',
	    value: function _getPrivateUserInfo() {
	      /**
	       * @type {UserViewModel}
	       */
	      var userViewModel = (0, _userApi.getUserViewModelFromLocalStorage)();
	      var email = userViewModel.email;
	
	      return { email: email };
	    }
	
	    /**
	     * @description Возвращает объект с ramblerID кодированный в строку алгоритмом sha256
	     * @returns {{ids: {ramblerID: (string|null)}}}
	     * @private
	     */
	
	  }, {
	    key: '_getRamblerIdUserInfo',
	    value: function _getRamblerIdUserInfo() {
	      /**
	       * @type {String}
	       */
	      var rid = window && window.rid;
	      return {
	        ids: {
	          ramblerID: rid ? (0, _sha.sha256)(rid) : null
	        }
	      };
	    }
	
	    /**
	     * @description Посылаем операцию о email подписке
	     * @param emailFromInput {String} - почта из инпута подписки
	     * @param responseCallback
	     * @see https://afisha.mindbox.ru/campaigns/7/operations/51/help
	     */
	
	  }, {
	    key: 'emailSubscribe',
	    value: function emailSubscribe(emailFromInput, responseCallback) {
	      var user = this._getRamblerIdUserInfo();
	      if (emailFromInput && emailFromInput !== '') {
	        this._send(OPERATIONS.SUBSCRIBE, {
	          customer: _extends({
	            email: emailFromInput,
	            subscriptions: [{ pointOfContact: 'Email' }]
	          }, user)
	        }).then(responseCallback);
	      } else {
	        throw new Error('user email is empty or wrong type: ' + (typeof emailFromInput === 'undefined' ? 'undefined' : _typeof(emailFromInput)));
	      }
	    }
	
	    /**
	     * @description Посылаем операцию авторизации пользователя, когда получили его данные из ID
	     * @see https://afisha.mindbox.ru/campaigns/7/operations/48/help
	     * @returns {Promise<*>}
	     */
	
	  }, {
	    key: 'auth',
	    value: function auth() {
	      var _getPrivateUserInfo2 = this._getPrivateUserInfo(),
	          email = _getPrivateUserInfo2.email,
	          phone = _getPrivateUserInfo2.phone;
	
	      var user = this._getRamblerIdUserInfo();
	      return this._send(OPERATIONS.AUTH, {
	        customer: _extends({
	          email: email,
	          mobilePhone: phone
	        }, user)
	      });
	    }
	  }]);
	
	  return MindBoxService;
	}();
	
	var service = new MindBoxService();
	exports.default = service;

/***/ }),

/***/ 950:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable */
	var CHAR_SIZE = 8;
	var HEX = '0123456789abcdef';
	var K = [0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786, 0xfc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x6ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2];
	var sha256 = exports.sha256 = function sha256(s) {
	  var safe_add = function safe_add(x, y) {
	    var lsw = (x & 0xffff) + (y & 0xffff);
	    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	    return msw << 16 | lsw & 0xffff;
	  };
	  var S = function S(X, n) {
	    return X >>> n | X << 32 - n;
	  };
	  var R = function R(X, n) {
	    return X >>> n;
	  };
	  var Ch = function Ch(x, y, z) {
	    return x & y ^ ~x & z;
	  };
	  var Maj = function Maj(x, y, z) {
	    return x & y ^ x & z ^ y & z;
	  };
	  var Sigma0256 = function Sigma0256(x) {
	    return S(x, 2) ^ S(x, 13) ^ S(x, 22);
	  };
	  var Sigma1256 = function Sigma1256(x) {
	    return S(x, 6) ^ S(x, 11) ^ S(x, 25);
	  };
	  var Gamma0256 = function Gamma0256(x) {
	    return S(x, 7) ^ S(x, 18) ^ R(x, 3);
	  };
	  var Gamma1256 = function Gamma1256(x) {
	    return S(x, 17) ^ S(x, 19) ^ R(x, 10);
	  };
	  var core_sha256 = function core_sha256(m, l) {
	    var result = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19];
	    var W = new Array(64);
	    var h1 = void 0,
	        h2 = void 0,
	        h3 = void 0,
	        h4 = void 0,
	        h5 = void 0,
	        h6 = void 0,
	        h7 = void 0,
	        h8 = void 0;
	    var T1 = void 0,
	        T2 = void 0;
	    m[l >> 5] |= 0x80 << 24 - l % 32;
	    m[(l + 64 >> 9 << 4) + 15] = l;
	    for (var i = 0; i < m.length; i += 16) {
	      h1 = result[0];
	      h2 = result[1];
	      h3 = result[2];
	      h4 = result[3];
	      h5 = result[4];
	      h6 = result[5];
	      h7 = result[6];
	      h8 = result[7];
	      for (var j = 0; j < 64; j++) {
	        W[j] = j < 16 ? m[j + i] : safe_add(safe_add(safe_add(Gamma1256(W[j - 2]), W[j - 7]), Gamma0256(W[j - 15])), W[j - 16]);
	        T1 = safe_add(safe_add(safe_add(safe_add(h8, Sigma1256(h5)), Ch(h5, h6, h7)), K[j]), W[j]);
	        T2 = safe_add(Sigma0256(h1), Maj(h1, h2, h3));
	        h8 = h7;
	        h7 = h6;
	        h6 = h5;
	        h5 = safe_add(h4, T1);
	        h4 = h3;
	        h3 = h2;
	        h2 = h1;
	        h1 = safe_add(T1, T2);
	      }
	      result[0] = safe_add(h1, result[0]);
	      result[1] = safe_add(h2, result[1]);
	      result[2] = safe_add(h3, result[2]);
	      result[3] = safe_add(h4, result[3]);
	      result[4] = safe_add(h5, result[4]);
	      result[5] = safe_add(h6, result[5]);
	      result[6] = safe_add(h7, result[6]);
	      result[7] = safe_add(h8, result[7]);
	    }
	    return result;
	  };
	  var str2binb = function str2binb(str) {
	    var bin = Array();
	    var mask = (1 << CHAR_SIZE) - 1;
	    for (var i = 0; i < str.length * CHAR_SIZE; i += CHAR_SIZE) {
	      bin[i >> 5] |= (str.charCodeAt(i / CHAR_SIZE) & mask) << 24 - i % 32;
	    }
	    return bin;
	  };
	  var Utf8Encode = function Utf8Encode(string) {
	    string = string.replace(/\r\n/g, '\n');
	    var utftext = '';
	    for (var n = 0; n < string.length; n++) {
	      var c = string.charCodeAt(n);
	      if (c < 128) {
	        utftext += String.fromCharCode(c);
	      } else if (c > 127 && c < 2048) {
	        utftext += String.fromCharCode(c >> 6 | 192);
	        utftext += String.fromCharCode(c & 63 | 128);
	      } else {
	        utftext += String.fromCharCode(c >> 12 | 224);
	        utftext += String.fromCharCode(c >> 6 & 63 | 128);
	        utftext += String.fromCharCode(c & 63 | 128);
	      }
	    }
	    return utftext;
	  };
	  var binb2hex = function binb2hex(binarray) {
	    var str = '';
	    for (var i = 0; i < binarray.length * 4; i++) {
	      str += HEX.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 + 4 & 0xf) + HEX.charAt(binarray[i >> 2] >> (3 - i % 4) * 8 & 0xf);
	    }
	    return str;
	  };
	  s = Utf8Encode(s);
	  return binb2hex(core_sha256(str2binb(s), s.length * CHAR_SIZE));
	};

/***/ })

/******/ });


// WEBPACK FOOTER //
// ramblerId.4e6a0ccf8125935348b9.js